import { render } from "./sidemenubar.vue?vue&type=template&id=0011f3ad&scoped=true&ts=true"
import script from "./sidemenubar.vue?vue&type=script&lang=ts"
export * from "./sidemenubar.vue?vue&type=script&lang=ts"

import "./sidemenubar.vue?vue&type=style&index=0&id=0011f3ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0011f3ad"]])

export default __exports__